export default {
  email_confirm: {
    header: {
      title: '이메일 주소 확인 완료',
    },
    completed: {
      section_one: '입력하신 이메일 주소로 로그인 ID와 패스워드를 보냈습니다.',
      section_two: '메일을 확인하신 후 메일 내용에 따라 로그인해 주세요.',
      section_three: '30분 후에도 메일이 도착하지 않는 경우는',
      section_four: '알려주세요. 담당자가 다시 연락드리겠습니다.',
    },
    expired: {
      section_one: '지정한 URL은 이미 유효기한이 지났습니다.',
      section_two: '이용을 원하는 경우는',
      section_three: '으로 알려주세요. 담당자가 다시 연락드리겠습니다.',
    },
    btn: {
      service_top: '서비스 톱',
      login: '로그인',
      register: '등록',
      rating_url: 'https://asuene.com/rating/en',
    },
  },
}
